"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIRTIME_TOPUP = exports.COLLECTION = exports.DELIVERY = exports.paymentTypes = exports.LAYBUY = exports.LOAN = exports.CARD = void 0;
exports.CARD = "card";
exports.LOAN = "loan";
exports.LAYBUY = "laybuy";
exports.paymentTypes = [exports.CARD, exports.LOAN, exports.LAYBUY];
// Delivery method enum values. Match the union type `"delivery" | "collection"`
// used by basket records and the LetsTrade order API.
exports.DELIVERY = "delivery";
exports.COLLECTION = "collection";
exports.AIRTIME_TOPUP = "airtime top-up";
